import { ServiceConfigurationV1 } from '@volkswagen-onehub/service-config-provider';
import { Esofertasv2FeatureAppDependencies } from '../../../index';

let featureServicesMirror: Esofertasv2FeatureAppDependencies;

export const saveFeatureServices = (
	featureServices: Esofertasv2FeatureAppDependencies,
) => {
	featureServicesMirror = featureServices;
};

const handleErrorInRetrievingExternalConfig = (): null => {
	console.error('Error retrieving Volkswagen Data service config provider.');
	return null;
};

export const getTenant = (dataService: ServiceConfigurationV1) => {
	return isPrivate(dataService)
		? dataService.tenantPrivate
		: isCommercial(dataService)
			? dataService.tenantCommercial
			: null;
};

export const isCommercial = (dataService: ServiceConfigurationV1) =>
	dataService.customConfig?.brand === 'N';
export const isPrivate = (dataService: ServiceConfigurationV1) =>
	dataService.customConfig?.brand === 'V';

export const checkTenant = (dataService: ServiceConfigurationV1) => {
	const tenant = getTenant(dataService);

	return tenant ? `/${tenant}` : '';
};

export const getDataUrl = (): string | null => {
	const data =
		featureServicesMirror['service-config-provider'].configs['es-vwdata'];

	if (!data) {
		return handleErrorInRetrievingExternalConfig();
	}

	return `${data.urlOrigin}${data.urlPath}${checkTenant(data)}`;
};
